<template>
  <v-container fluid class="text-xs-center pa-0 ma-0">

    <v-layout row class="ma-5 mb-0 ml-10 mr-10">
      <v-layout>
        <v-card-title class="ml-3">
          Update User Details
        </v-card-title>
      </v-layout>
      <v-layout class="justify-end mr-10">
        <v-switch
          v-if="editUserDetails"
          label="Change Password"
          class="pl-5 ml-5 mr-4"
          v-model="editUserPasswordDetails"
          color="#95C72B">
        </v-switch>
        <v-switch
          label="Edit"
          v-model="editUserDetails"
          color="#95C72B">
        </v-switch>
      </v-layout>
    </v-layout>
    <v-layout style="background-color: #ECECEC" class="pa-0 ma-0 mb-5">

      <v-row class="align-center justify-center">

        <!--          Profile Information Form-->
        <v-flex column class="ml-5 mt-5 lg10">
          <v-flex row class="align-center justify-center pa-0 ma-0">
            <h1 class="fieldName align-start justify-start">First Name</h1>
            <v-text-field
              class="textfields_style mb-1"
              background-color="#edf3ea"
              label="Enter first name"
              :disabled="!editUserDetails"
              v-model="firstName"
              solo
              hide-details
              append-icon="person"
              :readonly="editEnableUserdata"
              id="tf_name_field"
            />
            <h1 class="fieldName ml-5">Last Name</h1>
            <v-text-field :disabled="!editUserDetails" class="textfields_style mb-1"
                          background-color="#edf3ea"
                          label="Enter last name"
                          solo
                          hide-details
                          :readonly="editEnableUserdata"
                          append-icon="person"
                          v-model="lastName"
            />
          </v-flex>
          <v-flex row class="align-center justify-center pa-0 ma-0 mt-3">
            <h1 class="fieldName">Middle Name</h1>
            <v-text-field :disabled="!editUserDetails" class="textfields_style mb-1"
                          background-color="#edf3ea"
                          label="Enter middle name"
                          solo
                          hide-details
                          :readonly="editEnableUserdata"
                          append-icon="person"
                          v-model="middleName"
            />
            <h1 class="fieldName ml-5">Email Address</h1>
            <v-text-field :disabled="!editUserDetails" class="textfields_style mb-1"
                          background-color="#edf3ea"
                          label="Enter email address"
                          solo
                          hide-details
                          :readonly="editEnableUserdata"
                          append-icon="email"
                          v-model="emailId"
            />
          </v-flex>
          <v-flex row class="align-center justify-center pa-0 ma-0 mt-3">
            <h1 class="fieldName">Date of Birth</h1>
            <v-text-field class="textfields_style mb-1"
                          style="width: 27.5%"
                          :disabled="!editUserDetails"
                          background-color="#edf3ea"
                          label="Enter Date of Birth"
                          solo
                          hide-details
                          type="date"
                          v-model="dob"
            />
            <h1 class="fieldName ml-5">Contact</h1>
            <v-text-field class="textfields_style mb-1"
                          :disabled="!editUserDetails"
                          style="width: 27.5%"
                          background-color="#edf3ea"
                          label="Enter phone number"
                          solo
                          hide-details
                          type="text"
                          append-icon="phone"
                          v-model="contact"
            />
          </v-flex>
          <v-flex row class="align-center justify-center pa-0 ma-0 mt-3">
            <h1 class="fieldName">Address 1</h1>
            <v-text-field :disabled="!editUserDetails" class="textfields_style mb-1"
                          background-color="#edf3ea"
                          label="Enter address 1"
                          solo
                          hide-details
                          :readonly="editEnableUserdata"
                          append-icon="map"
                          v-model="address1"
            />
            <h1 class="fieldName ml-5">Address 2</h1>
            <v-text-field :disabled="!editUserDetails" class="textfields_style mb-1"
                          background-color="#edf3ea"
                          label="Enter address 2"
                          solo
                          hide-details
                          :readonly="editEnableUserdata"
                          append-icon="map"
                          v-model="address2"
            />
          </v-flex>
          <v-flex row class="align-center justify-center pa-0 ma-0 mt-3">
            <h1 class="fieldName">City</h1>
            <v-text-field class="textfields_style mb-1"
                          background-color="#edf3ea"
                          style="width: 27.5%;"
                          :disabled="!editUserDetails"
                          label="Enter city"
                          solo
                          hide-details
                          type="text"
                          append-icon="flag"
                          v-model="city"
            />
            <h1 class="fieldName ml-5">State</h1>
            <v-select
              :items="statesdata"
              class="textfields_style mb-1"
              style="width: 27.5%;"
              background-color="#edf3ea"
              :disabled="!editUserDetails"
              label="Enter state"
              solo
              hide-details
              type="text"
              append-icon="flag"
              v-model="state"
            ></v-select>

            <!--            <v-text-field :disabled="!editUserDetails" class="textfields_style mb-1"-->
            <!--                          background-color="#edf3ea"-->
            <!--                          label="Enter state"-->
            <!--                          solo-->
            <!--                          hide-details-->
            <!--                          :readonly="editEnableUserdata"-->
            <!--                          append-icon="map"-->
            <!--                          v-model="editUserdata['state']"-->
            <!--            />-->

          </v-flex>
          <v-flex row class="align-center justify-center pa-0 ma-0 mt-3">
            <h1 class="fieldName">Postal Code</h1>
            <v-text-field :disabled="!editUserDetails" class="textfields_style mb-1"
                          background-color="#edf3ea"
                          label="Enter postal code"
                          solo
                          hide-details
                          :readonly="editEnableUserdata"
                          append-icon="pin"
                          v-model="postalCode"
            />
            <h1 class="fieldName ml-5">Country Code</h1>
            <v-text-field :disabled="!editUserDetails" class="textfields_style mb-1"
                          background-color="#edf3ea"
                          label="Enter country code"
                          solo
                          hide-details
                          :readonly="editEnableUserdata"
                          append-icon="pin"
                          v-model="countryCode"
            />
          </v-flex>
          <v-flex v-if="editUserPasswordDetails && editUserDetails" row class="align-center justify-center pa-0 ma-0 mt-3">
            <h1 class="fieldName">Password</h1>
            <v-text-field class="textfields_style mb-1"
                          background-color="#edf3ea"
                          label="Enter new password"
                          :disabled="!editUserDetails"
                          solo
                          hide-details
                          type="text"
                          append-icon="lock"
                          v-model="newpassword"
            />

            <h1 class="fieldName ml-5">Confirm Password</h1>
            <v-text-field class="textfields_style mb-1"
                          background-color="#edf3ea"
                          label="Enter confirm password"
                          solo
                          hide-details
                          :disabled="!editUserDetails"
                          type="text"
                          append-icon="lock"
                          v-model="newpasswordconfirm"
            />
          </v-flex>


          <v-flex style="display: none"  row class="align-center justify-start pa-0 ma-0 mt-3">
            <h1 class="fieldName">Create Employee</h1>
            <v-switch
              v-model="createEmployee"
              color="#95C72B"
              style="width: 38%"
            ></v-switch>
            <h1 class="fieldName">Order Card</h1>
            <v-switch
              v-model="cardType"
              color="#95C72B"
            ></v-switch>
          </v-flex>
          <v-flex style="display: none"  row class="align-center justify-center pa-0 ma-0 mt-2">
            <h1 class="fieldName">Card Type</h1>
            <v-text-field :disabled="!editUserDetails" class="textfields_style"
                          background-color="#edf3ea"
                          label="Card program"
                          solo
                          hide-details
                          :readonly="editEnableUserdata"
                          append-icon="note"
                          v-model="payRate"
            />

            <h1 class="fieldName ml-5">Pay Rate</h1>
            <v-text-field :disabled="!editUserDetails" class="textfields_style"
                          background-color="#edf3ea"
                          label="Enter Pay Rate"
                          solo
                          hide-details
                          :readonly="editEnableUserdata"
                          append-icon="money"
                          v-model="payRate"
            />
          </v-flex>
          <v-flex style="display: none" row class="align-center justify-center pa-0 ma-0 mt-2">
            <h1 class="fieldName">SSN</h1>
            <v-text-field :disabled="!editUserDetails" class="textfields_style mb-1"
                          background-color="#edf3ea"
                          label="Enter SSN"
                          solo
                          hide-details
                          :readonly="editEnableUserdata"
                          append-icon="lock"
                          v-model="SSN"
            />
            <h1 class="fieldName ml-5">Pay Type</h1>
            <v-select
              :items="payTypes"
              class="mt-4"
              label="Select Pay Type"
              dense
              solo
              background-color="#edf3ea"
              v-model="payType"
            ></v-select>
          </v-flex>
          <transition duration="10000" v-if="add_details_error">
            <v-slide-y-transition>
              <div class="pa-2 red details-error-statement">
                {{this.add_details_error_string}}
              </div>
            </v-slide-y-transition>
          </transition>
          <v-flex>
            <v-btn
              v-if="editUserDetails"
              class="AddNewUser align-center justify-center mt-5"
              color="#8de867"
              large
              @click="updateUserDatavalue()"
            >
              SAVE
            </v-btn>
          </v-flex>
        </v-flex>
      </v-row>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "EditUserDetails",
  data: () => {
    return{
      statesdata : ["AK","AL","AR","AZ","CA","CO","CT","DC","DE","FL","GA","HI","IA","ID","IL","IN","KS","KY","LA","MA","MD","ME","MI","MN","MO","MS","MT","NC","ND","NE","NH","NJ","NM","NV","NY","OH","OK","OR","PA","PR","RI","SC","SD","TN","TX","UT","VA","VI","VT","WA","WI","WV","WY"],
      editDetails: false,
      payTypes: ['Hourly','Daily','Weekly', 'Monthly'],
      createEmployee: true,
      orderCard: true,
      firstName: '',
      lastName: '',
      middleName: '',
      emailId: '',
      dob: '',
      contact: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      postalCode: '',
      newpassword:'',
      newpasswordconfirm:'',
      countryCode: '',
      cardType: '',
      payRate: '',
      SSN: '',
      payType: '',
      editEnableUserdata:false,
      editUserPasswordDetails: false,
      add_details_error_string: "",
      add_details_error: false,

    };
  },
  props: {
    editUserdata: {
      type: Object,
      default: null
    },editUserDetails:{
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.editUserDetails = false
    this.updatecomponentvalue()
  },
  methods:{
    updatecomponentvalue: function(){
      this.firstName = this.editUserdata['first_name']
      this.lastName = this.editUserdata['last_name']
      this.middleName = this.editUserdata['middle_name']
      this.emailId = this.editUserdata['email']
      this.dob = this.editUserdata['date_of_birth']
      this.contact = this.editUserdata['phone_number']
      this.address1 = this.editUserdata['address_1']
      this.address2 = this.editUserdata['address_2']
      this.city = this.editUserdata['city']
      this.state = this.editUserdata['state']
      this.postalCode = this.editUserdata['postal_code']
      this.countryCode = this.editUserdata['country_code']
      this.cardType = ''// this.editUserdata['card_program']
      this.payRate = ''//this.selecteduser['pay_rate']
      this.SSN = ''//this.editUserdata['ssn']
      this.payType = ''//this.editUserdata['type']
      this.newpassword = ''

    },
    updateUserDatavalue(){
      {

        if(this.firstName == ""){
          this.add_details_error = true;
          this.add_details_error_string = "First Name cannot be empty";
        }
        else if(this.lastName == ""){
          this.add_details_error = true;
          this.add_details_error_string = "Last Name cannot be empty";
        }
        else if(this.middleName == ""){
          this.add_details_error = true;
          this.add_details_error_string = "Middle Name cannot be empty";
        }
        else if (this.emailId.match(
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ) == null) {
          this.add_details_error = true;
          this.add_details_error_string = "Please enter a valid email address";
        }
        else if(this.dob == ""){
          this.add_details_error = true;
          this.add_details_error_string = "DoB cannot be empty";
        }
        else if(this.contact == ""){
          this.add_details_error = true;
          this.add_details_error_string = "Contact number cannot be empty";
        }
        else if(this.address1 == ""){
          this.add_details_error = true;
          this.add_details_error_string = "Address cannot be empty";
        }
        else if(this.address2 == ""){
          this.add_details_error = true;
          this.add_details_error_string = "Address cannot be empty";
        }
        else if(this.city == ""){
          this.add_details_error = true;
          this.add_details_error_string = "City cannot be empty";
        }
        else if(this.state == ""){
          this.add_details_error = true;
          this.add_details_error_string = "State cannot be empty";
        }
        else if(this.postalCode == ""){
          this.add_details_error = true;
          this.add_details_error_string = "Postal Code cannot be empty";
        }
        else if(this.countryCode == ""){
          this.add_details_error = true;
          this.add_details_error_string = "Country Code cannot be empty";
        }
        else if(this.newpassword.length < 7 ){
          this.add_details_error = true;
          this.add_details_error_string = "Password cannot be less than 7 characters";

        }
        else if(this.newpasswordconfirm != this.newpassword)
        {
          this.add_details_error = true;
          this.add_details_error_string = "Confirm password and password are not same";

        }
          // else if(this.cardType == ""){
          //   this.add_details_error = true;
          //   this.add_details_error_string = "Card Type cannot be empty";
          // }
          // else if(this.payRate == ""){
          //   this.add_details_error = true;
          //   this.add_details_error_string = "Pay Rate cannot be empty";
          // }
          // else if(this.SSN == ""){
          //   this.add_details_error = true;
          //   this.add_details_error_string = "SSN cannot be empty";
        // }
        else{
          var userDetailsURL = this.$hostname+"/api/user/updateuser"
          /*var userDetailsData = new FormData();
          userDetailsData.append("address_1", this.address1)
          userDetailsData.append("address_2", this.address2)
          userDetailsData.append("card_program", this.cardType)
          userDetailsData.append("country_code", this.countryCode)
          userDetailsData.append("session",localStorage.getItem("session_id"))
          userDetailsData.append("date_of_birth", this.dob)
          userDetailsData.append("email", localStorage.getItem("email"))
          userDetailsData.append("first_name", this.firstName)
          userDetailsData.append("last_name", this.lastName)
          userDetailsData.append("middle_name", this.middleName)
          userDetailsData.append("pay_rate", this.payRate)
          userDetailsData.append("phone_number", this.contact)
          userDetailsData.append("postal_code", this.postalCode)
          userDetailsData.append("ssn", this.SSN)
          userDetailsData.append("state", this.state)
          userDetailsData.append("type", this.payType)
          userDetailsData.append("create_employee", true)
          userDetailsData.append("order_card", true)
          userDetailsData.append("city", this.city)*/
          var userDetailsData = {}
          userDetailsData["adminsession"]=localStorage.getItem("session_id")
          userDetailsData["adminemail"] = localStorage.getItem("email")

          userDetailsData["address_1"] = this.address1
          userDetailsData["address_2"] = this.address2
          userDetailsData["card_program"] = this.cardType
          userDetailsData["country_code"] = this.countryCode
          userDetailsData["date_of_birth"] = this.dob
          userDetailsData["email"] = this.emailId
          userDetailsData["first_name"] = this.firstName
          userDetailsData["last_name"] = this.lastName
          userDetailsData["middle_name"] = this.middleName
          userDetailsData["pay_rate"] = this.payRate
          userDetailsData["phone_number"] = this.contact
          userDetailsData["postal_code"] = this.postalCode
          userDetailsData["ssn"] = this.SSN
          userDetailsData["state"] = this.state
          userDetailsData["type"] = this.payType
          userDetailsData["create_employee"] = true
          userDetailsData["order_card"] = true
          userDetailsData["city"] = this.city
          userDetailsData["newpassword"] = this.newpassword

          this.$socket.client.emit('updateUserDataByAdmin', userDetailsData);
          return
          /*axios
            .post(userDetailsURL, userDetailsData)
            .then((response) => {
              if(response.data.state == 'Success'){
                alert("Record Updated Successfully")
                console.log(response)
              }
            })*/
        }
      }
    },
    logout(){
      this.$router.push({ name: 'Login'})
    }
  }
}
</script>

<style>
.v-select__selection--disabled{
  color: #8de867 !important;
  font-weight: bold;

}
input:disabled{
  color: #8de867 !important;
  font-weight: bold;
}
.fieldName{
  font-size: 12px;
  color: black;
  width: 13%;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/EditUserDetails.vue